import { DocumentUtil } from "./document.util";

declare var html2pdf: any;

export class PdfUtil {

  static ratio = 1;
  // static ratio = document.body.clientWidth / 1600;

  //`background-image: url('/assets/img/cards/${name}.jpg');`

  static fromHTML(html: string, filename: string) {
    const pdfElement = document.createElement('div');
    DocumentUtil.hideScroll();
    pdfElement.innerHTML = html;
    // document.body.appendChild(pdfElement);
    html2pdf(
      pdfElement,
      {
        filename,
        margin: 1,
      }
    );
    DocumentUtil.showScroll();
  }

  static toStaff(staffs, cardUrl, isstaff = false) {
    return `
      <style>
        body {
          background-color: white;
        }
        .container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding: 0;
          width: 100%;
        }

        .team {
        ` +
      `background: url('${cardUrl}');`
      + `
          height: ${320 * PdfUtil.ratio}px;
          width: ${960 * PdfUtil.ratio}px;
          margin-bottom: ${5 * PdfUtil.ratio}px;
          position: relative;
          background-size: ${940 * PdfUtil.ratio}px 100%;
          background-repeat: no-repeat;
        }

        .form-data {
          position: absolute;
          top: ${50 * PdfUtil.ratio}px;
          bottom: ${50 * PdfUtil.ratio}px;
          display: flex;
          font-size: ${18 * PdfUtil.ratio}px;
          font-family: sans-serif;
          color: #333;
          align-items: center;
        }

        .form-data .form-data-avatar {
          width: ${135 * PdfUtil.ratio}px;
          margin-right: ${18 * PdfUtil.ratio}px;
          height: ${140 * PdfUtil.ratio}px;
          overflow: hidden;
          background-size: cover;
        }

        .form-data .form-data-avatar img {
          height: 100%;
          max-width: 100%;
        }

        .player-name {
          margin-bottom: ${10 * PdfUtil.ratio}px;
        }

        .container > .page {
          margin-top: ${60 * PdfUtil.ratio}px;
          border: none;
        }

        label {
          color: #707070;
          font-size: 18px;
          font-weight: normal;
        }

        .label-dob {
          width: ${180 * PdfUtil.ratio}px;
          display: inline-block;
        }

        .mb-10 {
          margin-bottom: ${10 * PdfUtil.ratio}px;
        }
      </style>
      <div class="container">
      ` + staffs.map((staff, idx) => (idx % 4 === 0 ? '<div class="page">' : '') + `
        <div class="team">
          <div class="form-data">
            <div class="form-data-avatar">
              <img src="${staff.UserImage}" />
            </div>
            <div class="form-data-info">
              ${isstaff ? this.staffHtml(staff) : this.playerHtml(staff)}
            </div>
          </div>
        </div>` + (idx % 4 === 3 || idx === staff.length ? '</div>' : '')).join('\n') + `
      </div>
    `;
  }

  public static usClubStaff(staffs) {
    return `
      <style>
        body {
          width: 1400px;
          height: 1600px;
          background-color: white;
        }
        .container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
        }

        .page {
          padding-top: ${64 * PdfUtil.ratio}px;
          border: none;
        }

        .form-data {
          height: ${320 * PdfUtil.ratio}px;
          width: ${960 * PdfUtil.ratio}px;
          margin-bottom: ${5 * PdfUtil.ratio}px;
        }
        .card .info {
          display: flex;
          align-items: center;
          font-size: ${18 * PdfUtil.ratio}px;
        }
        .card .club-logo {
          margin-right: ${20 * PdfUtil.ratio}px;
        }
        .card .club-logo img {
          height: ${100 * PdfUtil.ratio}px;
        }
        .staff-info {
          display: flex;
          align-items: center;
          font-size: ${22 * PdfUtil.ratio}px;
        }

        .staff-avatar {
          margin-left: auto;
        }

        .staff-avatar img {
          height: ${150 * PdfUtil.ratio}px;
        }

        .us-logo {
          display: flex;
          align-items: center;
        }

        .sc-logo {
          margin-right: ${10 * PdfUtil.ratio}px;
        }

        .sc-logo img {
          height: ${40 * PdfUtil.ratio}px;
        }

        .card-footer {
          display: flex;
          align-items: center;
        }

        .tm-logo {
          height: ${80 * PdfUtil.ratio}px;
        }

        .logo {
          font-size: ${18 * PdfUtil.ratio}px;
        }
      </style>

      <div class="container">
      ` + staffs.map((staff, idx) => (idx % 4 === 0 ? '<div class="page">' : '') + `
        <div class="form-data">
          <div class="row card">
            <div class="col-xs-6 info">
              <div class="club-logo">
                <img src="${staff.ClubLogo}" />
              </div>
              <div class="club-name">
                <strong>${staff.ClubName}</strong>
              </div>
            </div>
            <div class="col-xs-6 logo">
              Staff - Competitive
            </div>
          </div>
          <div class="row card-info">
            <div class="col-xs-6">
              <div class="staff-info">
                <div>
                  <strong>${staff.PlayerName}</strong> <br />
                  ${staff.CoachID}
                </div>
                <div class="staff-avatar">
                  <img src="${staff.UserImage}" />
                </div>
              </div>
            </div>
          </div>
          <div class="row card-footer">
            <div class="col-xs-6 us-logo">
              <div class="sc-logo">
                <img src="/assets/img/cards/sc.png" />
              </div>
              <div class="expiration">
                <strong>EXPIRATION</strong> <br />
                ${staff.CardExpiration || ''}
              </div>
            </div>
            <div class="col-xs-6">
              <img class="tm-logo" src="/assets/img/cards/tm-logo.png" />
            </div>
          </div>
        </div>
        ` + (idx % 4 === 3 || idx === staff.length ? '</div>' : '')).join('\n') + `
      </div>
    `;
  }

  public static usClubPlayer(staffs) {
    return `
      <style>
        body {
          width: 1400px;
          height: 1600px;
          background-color: white;
        }

        .container {
          padding-top: ${64 * PdfUtil.ratio}px;
          width: ${960 * PdfUtil.ratio}px;
          align-items: center;
        }

        .form-data-avatar {
          width: ${135 * PdfUtil.ratio}px;
          margin-right: ${18 * PdfUtil.ratio}px;
          height: ${150 * PdfUtil.ratio}px;
          overflow: hidden;
          background-size: cover;
        }

        .form-data .form-data-info {
          line-height: 1.2;
          font-size: ${20 * PdfUtil.ratio}px;
          width: ${385 * PdfUtil.ratio}px;
        }

        .form-data-avatar img {
          width: 100%;
        }

        .page {
          border: none;
        }

        .container > .page:not(:last-child) {
          margin-bottom: ${65 * PdfUtil.ratio}px;
        }

        .card {
          display: flex;
          align-items: center;
        }

        .card .info {
          display: flex;
          align-items: center;
        }

        .card .logo {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .card .logo img {
          max-height: ${180 * PdfUtil.ratio}px;
        }

        .card .signature {
          font-size: ${18 * PdfUtil.ratio}px;
        }

        .form-data {
          margin-bottom: ${5 * PdfUtil.ratio}px;
          height: ${321.3 * PdfUtil.ratio}px;
        }

        .form-data-info {
          font-size: ${18 * PdfUtil.ratio}px;
        }

        .form-data-info strong {
          color: #555;
        }

        .form-data-info .player-name strong {
          color: black;
          margin-bottom: ${10 * PdfUtil.ratio}px;
        }

        .card-footer {
          background-color: #eee;
        }

        .registered-with {
          font-size: ${20 * PdfUtil.ratio}px;
          color: white;
          letter-spacing: 4px;
          line-height: 2;
          margin-left: ${10 * PdfUtil.ratio}px;
        }

        .club-info {
          display: flex;
          align-items: center;
        }

        .club-logo {
          width: ${80 * PdfUtil.ratio}px;
          margin-right: ${10 * PdfUtil.ratio}px;
          height: ${80 * PdfUtil.ratio}px;
          overflow: hidden;
          background-size: cover;
        }

        .club-logo img {
          width: 100%;
        }

        .sc-logo {
          margin-left: auto;
        }

        .sc-logo img {
          width: ${60 * PdfUtil.ratio}px;
        }
      </style>
      <div class="container">
      ` + staffs.map((staff, idx) => (idx % 4 === 0 ? '<div class="page">' : '') + `
        <div class="form-data">
          <div class="row card">
            <div class="col-xs-6 info">
              <div class="form-data-avatar">
                <img src="${staff.UserImage}" />
              </div>
              <div class="form-data-info">
                <div class="player-name"><strong>${staff.PlayerName}</strong></div>
                <div><strong>Player ID:</strong> ${staff.PlayerID}</div>
                <div><strong>DOB:</strong> ${staff.DOBText || 'N/A'}</div>
                <div><strong>Expiration:</strong> ${staff.CardExpiration === null ? '' : staff.CardExpiration}</div>
              </div>
            </div>
            <div class="col-xs-6 logo">
              <img src="/assets/img/cards/tm-logo.png" />
              <div class="signature">A player signature is not required.</div>
            </div>
          </div>
          <div class="row card-footer">
            <div class="registered-with">REGISTERED WITH</div>
            <div class="col-xs-6">
              <div class="club-info">
                <div class="club-logo">
                  <img src="${staff.ClubLogo}" />
                </div>
                <div class="club-name">
                  <strong>${staff.ClubName}</strong> <br />
                  <span class="clr-grey">PLAYER</span>
                </div>
                <div class="sc-logo">
                  <img src="/assets/img/cards/sc.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        ` + (idx % 4 === 3 || idx === staff.length ? '</div>' : '')).join('\n') + `
      </div>
    `;
  }

  private static staffHtml(staff) {
    return `
      <div class="mb-10"><strong>${staff.PlayerName}</strong></div>
      <div><label>CLUB NAME:</label></div>
      <div class="mb-10">${staff.ClubName}</div>
      <div><label>STAFF ID:</label> ${staff.CoachID}</div>
      <div>
        <div class="label-dob"><label>DOB:</label> ${staff.DOBText || 'N/A'}</div>
        <label>EXP:</label> ${staff.CardExpiration === null ? '' : staff.CardExpiration}
      </div>
    `;
  }

  private static playerHtml(staff) {
    return `
      <div class="mb-10"><strong>${staff.PlayerName}</strong></div>
      <div><label>CLUB/TEAM NAME:</label></div>
      <div class="mb-10">${staff.TeamName}</div>
      <div>
        <div class="label-dob"l><label>Player ID:</label> ${staff.PlayerID}</div>
        <label style="color:red;font-size:15px;"><small><strong> ${staff.DP ? 'DISCOVERY PLAYER' : ''}</strong></small></label>
      </div>
      <div>
        <div class="label-dob"><label>DOB:</label> ${staff.DOBText || 'N/A'}</div>
        <label>EXP:</label> ${staff.CardExpiration === null ? '' : staff.CardExpiration}
      </div>
    `;
  }

}



// WEBPACK FOOTER //
// ./src/app/models/utils/pdf.util.ts